import React, { useContext } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { Button, Space, Tabs, Tooltip } from 'antd';

import ApiSiteEditDialog from '@totem/components/administration/apiSites/ApiSiteEditDialog';
import ApiSitesContext from '@totem/components/administration/apiSites/ApiSitesContext';
import ApiSitesTable from '@totem/components/administration/apiSites/ApiSitesTable';
import { ApiSiteTab } from '@totem/components/administration/apiSites/types';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

export const ApiSitesExtra = () => {
  const { filteredData, onRefresh } = useContext(ApiSitesContext);

  return (
    <Space>
      <RecordCountBadge count={filteredData.length} />
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

const TAB_ITEMS: { key: ApiSiteTab; label: string }[] = [
  { key: 'current', label: 'Current Organization' },
  { key: 'unassigned', label: 'Unassigned' },
  { key: 'all', label: 'All' },
];

const ApiSitesLayout = () => {
  const { activeTab, onTabChange } = useContext(ApiSitesContext);

  return (
    <>
      <Tabs
        activeKey={activeTab}
        items={TAB_ITEMS}
        onChange={(key) => onTabChange(key as ApiSiteTab)}
      />
      <ApiSitesTable />
      <ApiSiteEditDialog />
    </>
  );
};

export default ApiSitesLayout;
